<template>
  <div>
    <!-- 微信认证组件 -->
    <wxAuth v-if="share" :share="share"></wxAuth>
    <headers :params="hraderP" />
    <!-- 第一个头 -->
    <div class="head-1">
      <img src="../../../assets/images/activities/desiagner/banner.png" alt="" />
      <!-- 标题  内容 -->
      <div class="loops" style="margin-top: -105px">
        <div class="title">
          <img src="../../../assets/images/activities/desiagner/title.png" />
          <span>设计师合伙人三大权益</span>
          <div class="content">
            <div
              class="detail first-detail"
            >
              <div class="flex-row">
                <img
                  src="../../../assets/images/activities/desiagner/sheji.png"
                  alt=""
                />
                <div class="flex-column">
                  <div class="quanyi-title">设计接单</div>
                  <div class="quanyi-content">
                    优先承接河姆渡推送的设计业务加微信：18339968807 了解详情
                  </div>
                </div>
              </div>

              <div class="qrcode" style="margin-top: 16px">
                <img
                  src="../../../assets/images/activities/desiagner/qrcode.png"
                  alt=""
                />
              </div>
            </div>
            <div
              class="detail second-detail"
            >
              <div class="flex-row">
                <img
                  src="../../../assets/images/activities/desiagner/hezuo.png"
                  alt=""
                />
                <div class="flex-column">
                  <div class="quanyi-title">项目合作</div>
                  <div class="quanyi-content" style="margin-top: 10px">
                    一单一议，有高额奖励
                  </div>
                </div>
              </div>
              <div
                class="button-style"
                @click="registerNow"
                style="margin-top: 10px"
              >
                立即登记
              </div>
            </div>
            <!-- 推荐有礼 -->
            <div
              class="detail three-detail"
            >
              <div class="flex-row">
                <img
                  src="../../../assets/images/activities/desiagner/tuijian.png"
                  alt=""
                />
                <div class="flex-column">
                  <div class="quanyi-title">推荐品牌</div>
                  <div class="quanyi-content">
                    推荐供应商入驻方案馆品牌专区<br />享高额奖励
                  </div>
                </div>
              </div>
              <div
                class="button-style"
                @click="recommend"
                style="margin-top: 22px"
              >
                立即推荐
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from '@/components/headers'
import { isMobile } from '@/utils/common'
import wxAuth from '@/components/wxAuth'
export default {
  name: 'rAndI',
  components: {
    headers,
    wxAuth
  },
  methods: {
    registerNow () {
      this.$router.push('/activity/dsg/projeceRegin.html')
    },
    recommend () {
      this.$router.push('/activity/dsg/recommendation.html')
    }
  },
  mounted () {
    if (!isMobile()) {
      console.log(`${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`)
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`
    }
  },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '合伙人三大权益',
        lefticon: true
      }
    }
  }
}
</script>

<style scoped>
.head-1 {
  width: 375px;
  height: 810px;
  background: rgba(46, 123, 255, 1);
}
.head-1 img {
  width: 375px;
  height: 201px;
  z-index: -1;
}
.loops {
  margin: 0 auto;
  width: 325px;
  height: 650px;
  background: #fff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.title {
  width: 325px;
  height: 38px;
  text-align: center;
  line-height: 28px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  position: relative;
}
.title img {
  width: 325px;
  height: 38px;
}
.title span {
  position: absolute;
  top: 2px;
  left: 26%;
}
.content {
  width: 325px;
  height: 157px;
  background: #fff;
  top: 37px;
  left: 0;
  position: absolute;
}
.detail {
  color: rgba(34, 34, 34, 1);
  width: 235px;
  height: 100px;
  background: rgba(47, 123, 255, 0.09);
  border-radius: 8px;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  padding: 12px 25px;
  text-indent: 2em;
  text-align: justify;
}
.detail img {
  width: 60px;
  height: 60px;
  z-index: 999;
}
.margin {
  margin: 0 auto;
}
.backage-body {
  margin-top: -4px;
  width: 100%;
  height: 450px;
  background: rgba(46, 123, 255, 1);
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}
.flex-row .step-img {
  width: 44px;
  height: 44px;
}
.flex-row .jian {
  font-size: 11px;
  color: #545454;
  text-align: left;
  width: 32px;
  margin-left: -12px;
}
.flex-row .step-title {
  font-size: 12px;
  font-weight: 400;
  color: #000b2f;
  width: 70px;
}
.flex-row .step-detail {
  width: 90px;
  font-size: 12px;
  white-space: nowrap;
  color: #545454;
  margin-left: -12px;
}
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  margin-left: 11px;
}
.quanyi-title {
  font-size: 15;
  font-weight: 400;
  color: #000b2f;
}
.quanyi-content {
  font-size: 12px;
  font-weight: 400;
  color: #6e6e6e;
}
.foot-button {
  width: 311px;
  height: 44px;
  background: #2f7bff;
  text-align: center;
  line-height: 44px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  border-radius: 26px;
  margin: 8px auto;
}
.qrcode {
  margin: 0 auto;
  width: 144px;
  height: 144px;
}
.qrcode img {
  width: 144px;
  height: 144px;
}
.button-style {
  width: 250px;
  height: 44px;
  background-image: linear-gradient(#6fa4ff, #2f7bff);
  border-radius: 5px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 44px;
  text-align: center;
  margin: 0 auto;
}
.label {
  margin: 0 auto;
  width: 168px;
  height: 14px;
  font-size: 12px;
  color: #6e6e6e;
}
.first-detail{
                  height: 248px;
                text-indent: 0em;
                padding: 9px 15px;
                width: 270px;
}
.second-detail{
                  height: 130px;
                text-indent: 0em;
                padding: 9px 15px;
                width: 270px;
                margin-top: 12px;
}
.three-detail{
                    height: 142px;
                text-indent: 0em;
                padding: 12px 15px;
                width: 270px;
                margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/activities/designer/rAndI.vue